<template>
  <div :style="styles.messageContainer">
    <div :style="styles.messageWrapper" >
      <template v-if="messageFrom === 'sender'">
        <div :style="styles.messageTextWrapper" >
          <p :style="styles.messageText" :class="`${routeLink}_fortext`">
            {{ STRINGS.SENDER_DELETED_MESSAGE }}
          </p>
        </div>
        <div :style="styles.messageInfoWrapper">
          <span :style="styles.messageTimeStamp">{{ messageTime }}</span>
        </div>
      </template>
      <template v-else-if="messageFrom === 'receiver'">
        <div :style="styles.messageThumbnail" v-if="isGroup">
          <comet-chat-avatar
            border-width="1px"
            corner-radius="50%"
            :image="message.sender.avatar"
            :border-color="theme.borderColor.primary"
          />
        </div>
        <div :style="styles.messageDetail">
          <div :style="styles.nameWrapper" v-if="isGroup">
            <span :style="styles.name">{{ message.sender.name }}</span>
          </div>
          <div :style="styles.messageTextWrapper">
            <p :style="styles.messageText">
              {{ STRINGS.RECEIVER_DELETED_MESSAGE }}
            </p>
          </div>
          <div :style="styles.messageInfoWrapper">
            <span :style="styles.messageTimeStamp">
              {{ messageTime }}
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
import {
  DEFAULT_OBJECT_PROP,
  DEFAULT_STRING_PROP,
} from "../../../resources/constants";

import { cometChatBubbles } from "../../../mixins/";

import { CometChatAvatar } from "../../Shared";

import * as style from "./style";

/**
 * Message bubble for deleted messages.
 *
 * @displayName CometChatDeleteMessageBubble
 */
export default {
  name: "CometChatDeleteMessageBubble",
  mixins: [cometChatBubbles],
  components: {
    CometChatAvatar,
  },
  props: {
    /**
     * The selected chat item object.
     */
    item: { ...DEFAULT_OBJECT_PROP },
    /**
     * Type of chat item.
     */
    type: { ...DEFAULT_STRING_PROP },
    /**
     * Theme of the UI.
     */
    theme: { ...DEFAULT_OBJECT_PROP },
    /**
     *
     */
    message: { ...DEFAULT_OBJECT_PROP },
    messageFrom: { ...DEFAULT_STRING_PROP },
  },
  computed: {
    /**
     * Computed styles for the bubble.
     */
    styles() {
      return {
        messageTextWrapper: style.messageTextWrapperStyle(
          this.theme,
          this.messageFrom
        ),
        name: style.nameStyle(this.theme),
        messageText: style.messageTextStyle(this.theme),
        messageThumbnail: style.messageThumbnailStyle(),
        messageTimeStamp: style.messageTimeStampStyle(this.theme),
        messageWrapper: style.messageWrapperStyle(this.messageFrom),
        messageContainer: style.messageContainerStyle(this.messageFrom),
        nameWrapper: style.nameWrapperStyle(this.message, this.messageFrom),
        messageInfoWrapper: style.messageInfoWrapperStyle(this.messageFrom),
        messageDetail: style.messageDetailStyle(this.message, this.messageFrom),
      };
    },
  },
};
</script>
<style scoped>
.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>